import { MODAL_TYPE } from "../constants";
import { MODALS_NAMESPACE_KEY } from "./constants";
import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";

const openIFrameModalFunctionName = "openIFrameModal";
const modalsNamespace = `${asosGlobalNamespace}.${siteChromeGlobalNamespace}.${MODALS_NAMESPACE_KEY}`;
const prependModalsNamespace = namespace => `${modalsNamespace}.${namespace}`;

const mandatoryParametersMessage = `
'${openIFrameModalFunctionName}' must be called with an object that has the following properties:
  - 'url': non-empty url string matching the current ASOS origin.
  - 'focusOnCloseElement': DOM Element.
  - 'consumer': non-empty string.
  - 'modalType': one of the following(from '${prependModalsNamespace(
    "MODAL_TYPE"
  )}') : ${Object.keys(MODAL_TYPE).join(", ")}.
`;

const isNonEmptyString = str => {
  return typeof str === "string" && str.trim().length > 0;
};

const isValidUrl = str => {
  try {
    return new URL(str).origin === window.location.origin;
  } catch {
    return false;
  }
};

export const validateOpenIFrameModalParams = params => {
  if (
    !(params && typeof params === "object" && Object.keys(params).length > 0)
  ) {
    throw new Error(mandatoryParametersMessage);
  }

  const { url, focusOnCloseElement, consumer, modalType, forceDOMRewrite } =
    params;

  const errorParams = [];

  if (!isValidUrl(url)) {
    errorParams.push("'url'");
  }

  if (!(focusOnCloseElement instanceof Element)) {
    errorParams.push("'focusOnCloseElement'");
  }

  if (!isNonEmptyString(consumer)) {
    errorParams.push("'consumer'");
  }

  if (!Object.values(MODAL_TYPE).includes(modalType)) {
    errorParams.push("'modalType'");
  }

  if (forceDOMRewrite && !(typeof forceDOMRewrite === "boolean")) {
    errorParams.push("'forceDOMRewrite'");
  }

  if (errorParams.length > 0) {
    throw new Error(`"The following parameters were missing or invalid when calling '${prependModalsNamespace(
      openIFrameModalFunctionName
    )}': ${errorParams.join(", ")}.
  ${mandatoryParametersMessage}`);
  }
};
